import { createSelector } from '@reduxjs/toolkit';
import modalsSelector from './modals';

const sourceConfigSelector = createSelector(modalsSelector, (modals) => modals.sourceConfig);

export default sourceConfigSelector;
